module.exports = __webpack_public_path__ + "assets/user-icon.8eeeb4d2.png";


//////////////////
// WEBPACK FOOTER
// ../source/assets/user-icon.png
// module id = 513
// module chunks = 26